<template>
    <div class="container-gauge">
        <div>
            <svg id="gauge" width="94" height="94" viewBox="0 0 94 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="92" height="92" rx="46" fill="var(--bg-color)" />
                <rect x="1" y="1" width="92" height="92" rx="46" stroke="url(#paint0_linear_196_513)"
                    stroke-width="2" />

                <path
                    d="M85 47C85 68.263 67.763 85.5 46.5 85.5C25.237 85.5 8 68.263 8 47C8 25.737 25.237 8.5 46.5 8.5C67.763 8.5 85 25.737 85 47Z"
                    fill="var(--bg-color)" stroke="#2983DD" stroke-width="7" stroke-dasharray="2 2" stroke-dashoffset="-1" />

                <text id="gauge-text" x="50%" y="50%" font-size="14" fill="var(--text-color)" text-anchor="middle"
                    alignment-baseline="middle">
                    <tspan class="valor" x="50%">{{ variavelCritica.valor }}</tspan>
                    <tspan class="unidade" x="50%" dy="1.2em">{{ variavelCritica.unidadeMedida }}</tspan>
                </text>


                <defs>
                    <linearGradient id="paint0_linear_196_513" x1="2" y1="47" x2="92" y2="47"
                        gradientUnits="userSpaceOnUse">
                        <stop offset="1" stop-color="#014A7A" />
                    </linearGradient>
                </defs>
            </svg>
        </div>
        <div :class="!variavelCritica.valorSetpoint ? 'ocultar' : ''" class="box-setpoint">
            <label>SP: {{ variavelCritica.valorSetpoint }}&nbsp;{{
                variavelCritica.unidadeMedida }}</label>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        variavelCritica: Object
    },
};
</script>
<style scoped>
.container-gauge {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.valor {
    font-weight: 600;
    font-size: 20px;
    line-height: 23.44px;
    text-align: center;
}

.unidadeMedida {
    font-weight: 400;
    font-size: 16px;
    line-height: 18.75px;
    text-align: center;
}

.box-setpoint {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 101px;
    height: 21px;
    border-radius: 5px;
    background: var(--linear-azul-claro);

    label {
        font-weight: 500;
        font-size: 12px;
        line-height: 14.06px;
        text-align: center;
    }
}

.ocultar {
    visibility: hidden;
}
</style>